// Generated by ReScript, PLEASE EDIT WITH CARE


let sdkDomainUrl = sdkUrl + publicPath;

let apiEndPoint = {
  contents: undefined
};

function setApiEndPoint(str) {
  apiEndPoint.contents = str;
}

function getApiEndPoint(publishableKeyOpt, isConfirmCallOpt) {
  let publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  let isConfirmCall = isConfirmCallOpt !== undefined ? isConfirmCallOpt : false;
  publishableKey.startsWith("pk_snd_");
  let str = apiEndPoint.contents;
  if (str !== undefined) {
    return str;
  } else if (isConfirmCall) {
    return confirmEndPoint;
  } else {
    return backendEndPoint;
  }
}

function hyperswitchVaultEndPoint(publishableKeyOpt) {
  let publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  return getApiEndPoint(publishableKey, undefined);
}

function getVaultEndPoint(publishableKeyOpt) {
  let publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  if (isPciCompliant || isLocal) {
    return getApiEndPoint(publishableKey, undefined);
  } else {
    return hyperswitchVaultEndPoint(publishableKey);
  }
}

let hyperswitchVaultSdkUrl = sdkUrl;

let vaultSdkDomainUrl = isPciCompliant || isLocal ? sdkDomainUrl : hyperswitchVaultSdkUrl + publicPath;

function addCustomPodHeader(arr, customPodUri) {
  if (customPodUri !== undefined && customPodUri !== "") {
    arr.push([
      "x-feature",
      customPodUri
    ]);
  }
  return Object.fromEntries(arr);
}

let switchToInteg = false;

let isLocal$1 = false;

export {
  switchToInteg,
  isLocal$1 as isLocal,
  sdkDomainUrl,
  apiEndPoint,
  setApiEndPoint,
  getApiEndPoint,
  hyperswitchVaultEndPoint,
  getVaultEndPoint,
  hyperswitchVaultSdkUrl,
  vaultSdkDomainUrl,
  addCustomPodHeader,
}
/* sdkDomainUrl Not a pure module */
